import { site } from "@/config/site";

export const hasConsent = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem("mbc-consent") === "accepted";

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (hasConsent() && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
  if (hasConsent() && typeof window.fbq === "function") {
    window.fbq("trackCustom", name, params);
  }
}

// Captured once per session on first landing — survives in-site navigation so
// ad campaigns and referrers are attributed to the enquiry no matter where it converts.
export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const stored = window.sessionStorage.getItem("mbc_attr");
    if (stored) return JSON.parse(stored);
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach(
      (k) => params.get(k) && (utm[k] = params.get(k)),
    );
    const attr = {
      utm,
      gclid: params.get("gclid") || "",
      referrer: document.referrer || "",
      landing_page: window.location.pathname,
    };
    window.sessionStorage.setItem("mbc_attr", JSON.stringify(attr));
    return attr;
  } catch {
    return {};
  }
}

function loadGA4(id) {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
  if (site.analytics.googleAds) {
    window.gtag("config", site.analytics.googleAds);
  }
}

function loadGTM(id) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(s);
}

function loadMetaPixel(id) {
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq =
    window.fbq ||
    function () {
      (window.fbq.queue = window.fbq.queue || []).push(arguments);
    };
  window.fbq("init", id);
  window.fbq("consent", "grant");
  window.fbq("track", "PageView");
}

// Loads non-essential trackers only after cookie consent. IDs come from site settings/env.
export function initAnalytics() {
  if (!hasConsent()) return;
  const { ga4, gtm, metaPixel } = site.analytics;
  if (ga4) loadGA4(ga4);
  if (gtm) loadGTM(gtm);
  if (metaPixel) loadMetaPixel(metaPixel);
}
